import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionHeader from "./sectionHeader";
import SectionSubHeader from "./sectionSubHeader";
import { AboutRotate } from "../assets/svg";
import CustomButton from "./CustomButton";
import { useNavigate } from "react-router-dom";

const PageBanner = ({ type, header, descrption, smallHeader, bannerimage , varient}) => {
  const navigate = useNavigate();
  return (
    <>
      {type === "about" && (
        <div
          className={`${
            type === "about" ? "aboutBanner" : "-"
          } volto-page-banner`}
        >
          <span className="grident-blur"></span>
          <Container className="h-100">
            <SectionHeader mainText1={"ABOUT"} mainText2={"US"} />
            <Row>
              <Col lg={6}>
                <div className="about-container">
                  <SectionSubHeader headerText={"Built to Make an Impact"} />
                </div>
              </Col>

              <Col lg={4}>
                <div className="about-container">
                  <p>{descrption}</p>
                </div>
              </Col>
              <Col lg={2}>
                <div className="about-container text-end">
                  <AboutRotate />
                </div>
              </Col>
            </Row>
          </Container>

          <img
            className="banner-vector img-fluid"
            src="/images/Union.svg"
            alt="banner-vector"
          />
          <div className="about-banner-image overflow-hidden">
            <img
              className=""
              src="/images/about_banner.webp"
              alt="about_banner"
            />
          </div>
          <img
            className="banner-vector img-fluid"
            src="/images/Union.svg"
            alt="banner-vector"
          />
        </div>

      )}
        {type === "industries" && (
        <div
          style={{backgroundImage : `url(${bannerimage})`}}
          className={`${
            type === "industries" ?  `industriesBanner ${varient}` : "-"
          } volto-page-banner`}
        >
          <Container className="h-100">
            <Row className="h-100 banner-row">
              <Col lg={6}>
                <div className="industries-container">
                  <SectionSubHeader headerText={header} />
                </div>
              </Col>

              <Col lg={6}>
                <div className="industries-container banner">
                  <p>{descrption}</p>
                  <div className='mt-3'><CustomButton buttonText='Let’s Talk' buttonType='bannerBtn'  arrow onClick={() => navigate("/contact")}/></div>
                </div>
              </Col>
            </Row>
          </Container>
          <img
            className="banner-vector img-fluid"
            src="/images/Union.svg"
            alt="banner-vector"
          />
          
        </div>
      )}
    </>
  );
};

export default PageBanner;
